function cov_1uahnu3vxk() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp12.tsx";
  var hash = "190bb1e53c2e74a304e87b3b3d36d10ea8ea211f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronUp12.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "190bb1e53c2e74a304e87b3b3d36d10ea8ea211f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1uahnu3vxk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1uahnu3vxk();
var Icon = (cov_1uahnu3vxk().s[0]++, {
  name: 'chevron-up-12',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.11612 8.38388C1.62796 7.89573 1.62796 7.10427 2.11612 6.61612L5.11612 3.61612C5.60427 3.12796 6.39573 3.12796 6.88388 3.61612L9.88388 6.61612C10.372 7.10427 10.372 7.89573 9.88388 8.38388C9.39573 8.87204 8.60427 8.87204 8.11612 8.38388L6 6.26777L3.88388 8.38388C3.39573 8.87204 2.60427 8.87204 2.11612 8.38388Z\" fill=\"currentColor\"/>"
});
export default Icon;